module.exports = __webpack_public_path__ + "static/bassoon_cn-1e31dce3c5a496be7a4c3da4f9edc959.pdf";